<template>
  <div v-if="$can([abilities.VIEW_USER, abilities.VIEW_RIGHT])" class="col-sm-3 mb-5 mb-xl-10" >
    <div class="card card-flush h-lg-100">
      <div class="card-header pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bolder text-dark">{{$t('setting.setting_user')}}</span>
          <span class="text-gray-400 mt-1 fw-bold fs-6"></span>
        </h3>
      </div>
      <div class="card-body pt-5">
        <router-link :to="'settings-user/users'" v-if="$can(abilities.VIEW_USER)" >
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.users')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
        <router-link :to="'settings-user/groups'" v-if="$canAccess(moduleAbilities.ACCESS)">
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.usersGroups')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
        <router-link :to="'settings-user/rights'" v-if="$can(abilities.VIEW_RIGHT)">
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.right')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import abilities from "@/composables/abilities";
import moduleAbilities from "@/composables/moduleAbilities";
</script>
<style scoped>

</style>
